export const careerItem = [
	{
		"id":1,
		"icon":"fa-apple",
		"title":"iOS Developer",
		"experience":"1-3 years",
		"location":"Indore, India",
		"skills":[
					"Strong knowledge of OOPS concepts Laravel Developer",
					"Strong knowledge of Core Java/Kotlin concepts",
					"Strong knowledge of Android UI design principles, patterns, and best practices",
					"Understanding of Google’s Android design principles and interface guidelines",
					"REST API concepts",
					"Design Patterns",
					"Data Structure/Collection framework",
					"Preferences, SQLite",
					"Push Notifications",
					"In-App Purchase",
					"Publishing app on Google PlayStore",
					"Understanding of Android app architecture",
					"Gradle / Third party libraries integration",
					"Knowledge of Android development tools",
					"Good communication skills",
					"Hands-on exposure on SCMs like Git, BitBucket, SVN etc"
				],
		"description":"Skills Required: Strong knowledge of OOPS concepts IOS – Developer Strong knowledge of Core Java/Kotlin concepts Strong knowledge of Android UI design principles, patterns, and best practices",
	},
	{
		"id":2,
		"icon":"fa-android",
		"title":"Android Developer",
		"experience":"1-3 years",
		"location":"Indore, India",
		"skills":[
			"Strong knowledge of OOPS concepts Laravel Developer",
			"Strong knowledge of Core Java/Kotlin concepts",
			"Strong knowledge of Android UI design principles, patterns, and best practices",
			"Understanding of Google’s Android design principles and interface guidelines",
			"REST API concepts",
			"Design Patterns",
			"Data Structure/Collection framework",
			"Preferences, SQLite",
			"Push Notifications",
			"In-App Purchase",
			"Publishing app on Google PlayStore",
			"Understanding of Android app architecture",
			"Gradle / Third party libraries integration",
			"Knowledge of Android development tools",
			"Good communication skills",
			"Hands-on exposure on SCMs like Git, BitBucket, SVN etc"
		],
		"description":"Skills Required: Strong knowledge of OOPS concepts IOS – Developer Strong knowledge of Core Java/Kotlin concepts Strong knowledge of Android UI design principles, patterns, and best practices",
	},
	{
		"id":3,
		"icon":"fa-laptop",
		"title":"FullStack  Developer",
		"experience":"1-3 years",
		"location":"Indore, India",
		"skills":[
			"Strong knowledge of OOPS concepts Laravel Developer",
			"Strong knowledge of Core Java/Kotlin concepts",
			"Strong knowledge of Android UI design principles, patterns, and best practices",
			"Understanding of Google’s Android design principles and interface guidelines",
			"REST API concepts",
			"Design Patterns",
			"Data Structure/Collection framework",
			"Preferences, SQLite",
			"Push Notifications",
			"In-App Purchase",
			"Publishing app on Google PlayStore",
			"Understanding of Android app architecture",
			"Gradle / Third party libraries integration",
			"Knowledge of Android development tools",
			"Good communication skills",
			"Hands-on exposure on SCMs like Git, BitBucket, SVN etc"
		],
		"description":"Skills Required: Strong knowledge of OOPS concepts IOS – Developer Strong knowledge of Core Java/Kotlin concepts Strong knowledge of Android UI design principles, patterns, and best practices",
	},
	{
		"id":4,
		"icon":"fa-wordpress",
		"title":"Wordpress Developer",
		"experience":"1-3 years",
		"location":"Indore, India",
		"skills":[
			"Strong knowledge of OOPS concepts Laravel Developer",
			"Strong knowledge of Core Java/Kotlin concepts",
			"Strong knowledge of Android UI design principles, patterns, and best practices",
			"Understanding of Google’s Android design principles and interface guidelines",
			"REST API concepts",
			"Design Patterns",
			"Data Structure/Collection framework",
			"Preferences, SQLite",
			"Push Notifications",
			"In-App Purchase",
			"Publishing app on Google PlayStore",
			"Understanding of Android app architecture",
			"Gradle / Third party libraries integration",
			"Knowledge of Android development tools",
			"Good communication skills",
			"Hands-on exposure on SCMs like Git, BitBucket, SVN etc"
		],
		"description":"Skills Required: Strong knowledge of OOPS concepts IOS – Developer Strong knowledge of Core Java/Kotlin concepts Strong knowledge of Android UI design principles, patterns, and best practices",
	},
	{
		"id":5,
		"icon":"fa-laptop",
		"title":"PHP Developer",
		"experience":"1-3 years",
		"location":"Indore, India",
		"skills":[
			"Strong knowledge of OOPS concepts Laravel Developer",
			"Strong knowledge of Core Java/Kotlin concepts",
			"Strong knowledge of Android UI design principles, patterns, and best practices",
			"Understanding of Google’s Android design principles and interface guidelines",
			"REST API concepts",
			"Design Patterns",
			"Data Structure/Collection framework",
			"Preferences, SQLite",
			"Push Notifications",
			"In-App Purchase",
			"Publishing app on Google PlayStore",
			"Understanding of Android app architecture",
			"Gradle / Third party libraries integration",
			"Knowledge of Android development tools",
			"Good communication skills",
			"Hands-on exposure on SCMs like Git, BitBucket, SVN etc"
		],
		"description":"Skills Required: Strong knowledge of OOPS concepts IOS – Developer Strong knowledge of Core Java/Kotlin concepts Strong knowledge of Android UI design principles, patterns, and best practices",
	},
	{
		"id":6, 
		"icon":"fa-user",
		"title":"HR ",
		"experience":"1-3 years",
		"location":"Indore, India",
		"skills":[
			"Strong knowledge of OOPS concepts Laravel Developer",
			"Strong knowledge of Core Java/Kotlin concepts",
			"Strong knowledge of Android UI design principles, patterns, and best practices",
			"Understanding of Google’s Android design principles and interface guidelines",
			"REST API concepts",
			"Design Patterns",
			"Data Structure/Collection framework",
			"Preferences, SQLite",
			"Push Notifications",
			"In-App Purchase",
			"Publishing app on Google PlayStore",
			"Understanding of Android app architecture",
			"Gradle / Third party libraries integration",
			"Knowledge of Android development tools",
			"Good communication skills",
			"Hands-on exposure on SCMs like Git, BitBucket, SVN etc"
		],
		"description":"Skills Required: Strong knowledge of OOPS concepts IOS – Developer Strong knowledge of Core Java/Kotlin concepts Strong knowledge of Android UI design principles, patterns, and best practices",
	}
]; 

/*
export default [
	{ id: '1', imageName: 'img1.jpeg', tag: 'free' },
	{ id: '2', imageName: 'img2.jpeg', tag: 'new' },
	{ id: '3', imageName: 'img3.jpeg', tag: 'pro' },
	{ id: '4', imageName: 'img4.jpeg', tag: 'pro' },
	{ id: '5', imageName: 'img5.jpeg', tag: 'free' },
	{ id: '6', imageName: 'img6.jpeg', tag: 'new' },
	{ id: '7', imageName: 'img6.jpeg', tag: 'pro' },
	{ id: '8', imageName: 'img8.jpeg', tag: 'free' },
	{ id: '9', imageName: 'img9.jpeg', tag: 'new' },
	{ id: '10', imageName: 'img10.jpeg', tag: 'new' },
	{ id: '11', imageName: 'img11.jpeg', tag: 'new' },
	{ id: '12', imageName: 'img12.jpeg', tag: 'new' },
	{ id: '13', imageName: 'img13.jpeg', tag: 'free' },
	{ id: '14', imageName: 'img14.jpeg', tag: 'pro' },
	{ id: '15', imageName: 'img15.jpeg', tag: 'free' },
	{ id: '16', imageName: 'img16.jpeg', tag: 'new' }
];

*/
